import _get from 'lodash/get';

const account = {
  isLargeAccount(state) {
    const userEmail = _get(state, 'userInfo.user.email', '');
    const largeAccount = state.largeAccounts.indexOf(userEmail) >= 0;
    return largeAccount;
  },
};

const calendarEvents = {
  calendarEventEmails(state) {
    return state.calendarEventEmails;
  },
  calendarEventNotifications(state) {
    return state.calendarEventNotifications;
  },
  calendarEventEmailChanges(state) {
    return state.calendarEventEmailChanges;
  },
  /* PAST EVENTS */
  pastEventEmails(state) {
    return state.pastEventEmails;
  },
  pastEventNotifications(state) {
    return state.pastEventNotifications;
  },
  pastEventEmailChanges(state) {
    return state.pastEventEmailChanges;
  },
  pastEventNotificationChanges(state) {
    return state.pastEventNotificationChanges;
  },
};

/* GETTERS: Putting it all together */
const getters = {
  getVal(state, path) {
    return (path) => {
      return _get(state, path, null);
    };
  },
  ...account,
  ...calendarEvents,
};

export default getters;
